module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr. Magalie Cadieux.4d76dd0f.JPG";